import { createContext, useContext, useState } from "react";
import { SiteLoginDialog } from "./SiteLoginDialog";

const SiteAccessContext = createContext(null);

export const SiteAccessProvider = ({ children }) => {
  const [mode, setMode] = useState(null);
  return <SiteAccessContext.Provider value={setMode}>{children}{mode && <SiteLoginDialog key={mode} mode={mode} onClose={() => setMode(null)} />}</SiteAccessContext.Provider>;
};

export const SiteAccessButton = ({ mode, children, ...props }) => {
  const open = useContext(SiteAccessContext);
  return <button type="button" {...props} onClick={() => open(mode)}>{children}</button>;
};